
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import API, { auth,apikey } from '../../constants/api';
import {
    GATEWAY_FETCH,
} from '../actions';

import {
    gatewaySuccess,
    gatewayFail,
} from './actions';

const gatewayFetchAsync = async (data) =>

	 await API.get('/gateway',
	 {
      headers : {
        'Content-Type': 'application/json',
		  'apikey': '87cdf9229caf9a7fa3fd1403bcc5dd97',
		  'useId': data,
      }
    })
        .then(data => data)
        .catch(error => error);



//* Get gateway List
function* gatewayFetch({ payload }) {

    try {
		 const{ gatewaylist } = payload;
		  const gatewayFetch = yield call(gatewayFetchAsync , gatewaylist);

        if (gatewayFetch.data.StatusCode === "0000") {
            yield put(gatewaySuccess(gatewayFetch.data.ResultValues));
        } else {
            yield put(gatewayFail(gatewayFetch.data.Message));
        }
    } catch (error) {
        yield put(gatewayFail(error));
    }
}



export function* watchGatewayFetch() {
    yield takeEvery(GATEWAY_FETCH, gatewayFetch)
}

export default function* rootSaga() {
    yield all([
        fork(watchGatewayFetch),
    ]);
}
